import { MultipleChoiceListDataPoint } from '@vyce/core/src/types';
import { Fade, Paper } from '@material-ui/core';
import { FormSummaryQuestionTitle } from './FormSummaryQuestionTitle';
import { FormSummaryBarChart } from './FormSummaryBarChart';

export const FormSummaryMultipleChoice = ({
  data,
  title,
  totalAnswers,
  description,
  videoLink,
  photoUrl,
  explanation,
  pdfUrl,
  onItemClick,
}: {
  data: MultipleChoiceListDataPoint[];
  title: string;
  totalAnswers: number;
  description?: string;
  videoLink?: string;
  photoUrl?: string;
  explanation?: string;
  pdfUrl?: string;
  onItemClick?: (answerValue: string, answerLabel: string) => void;
}) => {
  return (
    <Fade in={true} timeout={200} style={{ width: '100%' }}>
      <Paper variant="outlined" style={{ padding: 24, width: '100%', minHeight: 350, height: '100%' }}>
        <FormSummaryQuestionTitle
          title={title}
          totalAnswers={totalAnswers}
          description={description}
          videoLink={videoLink}
          photoUrl={photoUrl}
          explanation={explanation}
          pdfUrl={pdfUrl}
        />
        <FormSummaryBarChart data={data} layout="horizontal" onItemClick={onItemClick} />
      </Paper>
    </Fade>
  );
};
